"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OutsideAlerter = _interopRequireDefault(require("./OutsideAlerter"));
var _jsxRuntime = require("react/jsx-runtime");
var PositionWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchWithDropdown__PositionWrapper",
  componentId: "sc-vq2buw-0"
})(["position:relative;"]);
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchWithDropdown__InputWrapper",
  componentId: "sc-vq2buw-1"
})([""]);
var SearchWithDropdown = function SearchWithDropdown(_ref) {
  var children = _ref.children,
    DropdownMenu = _ref.DropdownMenu;
  var _ref2 = (0, _react.useState)(),
    _ref3 = _slicedToArray(_ref2, 2),
    expanded = _ref3[0],
    setExpanded = _ref3[1];
  var openDropdown = function openDropdown() {
    if (!expanded) setExpanded(true);
  };
  var closeDropdown = function closeDropdown() {
    if (expanded) setExpanded(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PositionWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OutsideAlerter.default, {
      callback: closeDropdown,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(InputWrapper, {
        onChange: openDropdown,
        onClick: openDropdown,
        children: children
      }), expanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownMenu, {
        close: closeDropdown
      })]
    })
  });
};
SearchWithDropdown.defaultProps = {};
var _default = exports.default = SearchWithDropdown;